/* eslint-disable react/prop-types */
import { Button, Flex } from 'antd';
import FileIcon from 'Assets/icons/icon-file.svg';
import EditIcon from 'Containers/Settings/Profile/EditIcon';
import { AI_CHECKER_GA_EVENT } from 'Containers/Teleconsult/Main/AINotes/constants';

import SummaryReviewForm from '../../SummaryContent/SummaryReviewForm';
import useCheckHealthSummary from '../../hooks/useCheckHealthSummary';
import useAiCheckerLogEvent from '../../hooks/useAiCheckerLogEvent';

import styles from './Summary.less';

const Summary = ({ doctor, consult, enableEdit, setEnableEdit, formRef }) => {
  const { data: content, isLoading } = useCheckHealthSummary();

  const { score, consultId } = content || {};

  const { logAICheckerEvent } = useAiCheckerLogEvent(score);

  const handleClickEdit = () => {
    setEnableEdit(true);
    logAICheckerEvent(AI_CHECKER_GA_EVENT.AI_CHECKER_REPORT_EDIT, {
      consult_id: consultId,
      doctor_id: doctor.id,
    });
  };
  return (
    <Flex vertical>
      <Flex className={styles.header} align="center" justify="space-between">
        <Flex gap={8} align="center">
          <img src={FileIcon} alt="File Icon" />
          <div className={styles.title}>Consult Summary</div>
        </Flex>
        {!enableEdit && (
          <Button onClick={handleClickEdit} disabled={isLoading}>
            <EditIcon />
            Edit
          </Button>
        )}
      </Flex>
      <Flex className={styles.content}>
        <SummaryReviewForm
          doctor={doctor}
          consult={consult}
          enable={enableEdit}
          formRef={formRef}
        />
      </Flex>
    </Flex>
  );
};

export default Summary;
